import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_STUDENTSCORE,
  GET_STUDENTSCORES,
  GET_STUDENTSCORES_BY_FILTER,
  GET_STUDENTSCORES_FOR_TEACHER,
  ADD_STUDENTSCORE,
  UPDATE_STUDENTSCORE,
  UPDATE_STUDENTSCORE_ARRAY,
  DELETE_STUDENTSCORE,
  RECREATE_STUDENTSCORE
} from '@/queries/modules/student-score/student-score.js';

export async function getStudentScores(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTSCORES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentScores', data.getStudentScores);
      context.commit('setSuccess', null);
      return data.getStudentScores
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentScoresByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTSCORES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentScores', data.getStudentScoresByFilter);
      context.commit('setSuccess', null);

      return data.getStudentScoresByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentScoresForTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTSCORES_FOR_TEACHER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentScores', data.getStudentScoresForTeacher);
      context.commit('setSuccess', null);

      return data.getStudentScoresForTeacher;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentScore(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTSCORE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setStudentScore', data.getStudentScore);
      context.commit('setSuccess', null);
      return data.deleteStudentScore
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function reCreateStudentScore(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: RECREATE_STUDENTSCORE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setStudentScores', data.reCreateStudentScore);
      context.commit('setSuccess', updateItemSuccess(data.reCreateStudentScore.length));
      return data.reCreateStudentScore;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentScore(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTSCORE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const studentScores = [...context.state.studentScores];
      studentScores.push(data.addStudentScore);
      context.commit('setStudentScores', studentScores);
      context.commit('setSuccess', newItemSuccess(data.addStudentScore.student.code));

      return data.addStudentScore;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
export async function updateStudentScore(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTSCORE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentScores.findIndex(item => item.id === data.updateStudentScore.id);
      const studentScores = [
        ...context.state.studentScores.slice(0, index),
        data.updateStudentScore,
        ...context.state.studentScores.slice(index + 1)
      ];
      context.commit('setStudentScores', studentScores);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentScore.student.code));

      return data.updateStudentScore
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentScoreArray(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTSCORE_ARRAY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setStudentScores', data.updateStudentScoreArray);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentScoreArray.length));

      return data.updateStudentScoreArray
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStudentScore(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STUDENTSCORE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.studentScores.findIndex(item => item.id === data.deleteStudentScore.id);
      const studentScores = [
        ...context.state.studentScores.slice(0, index),
        ...context.state.studentScores.slice(index + 1)
      ];
      context.commit('setStudentScores', studentScores);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStudentScore.student.code));

      return data.deleteStudentScore
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

